import React, { useState } from 'react';

import { useSound } from '../App';
import { useAppContext } from '../context/AppContext'; // 引入 useAppContext hook

import { ReliableFetch } from "../utils/ReliableFetch.ts";  // ✅ 别名导入（推荐）

const Register = ({ onRegister }) => {
    //========================================================================
    const { ServiceURLPrefix,
        username, setUsername,
        blockPage, unblockPage,
        setMessage,
    } = useAppContext(); // 获取当前的服务器地址
    //========================================================================
    const [playSound] = useSound('/goldcoin.mp3');
    //========================================================================
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        playSound();
        blockPage();
        if (password !== confirmPassword) {
            setMessage("两次输入的密码不一致！");
            unblockPage();
            return;
        }
        try {
            const response = await ReliableFetch(`${ServiceURLPrefix}/auth/register`, {
                method: 'POST',
                credentials: 'include',  // ★带cookie的关键★                
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })//前后端属性名得完全相同
                // headers: {
                //     'Content-Type': 'application/x-www-form-urlencoded',
                // },
                // body: `username=${username}&password=${password}`,
            });
            const data = await response.json();
            if (response.ok) {
                setMessage("注册成功，正在登录...");
                // 调用父组件传入的回调函数以更新登录状态
                onRegister(`欢迎，${username}！`);
            } else {
                setMessage(data.detail || "注册失败！");
            }
        } catch (error) {
            console.error("注册时发生错误:", error);
            setMessage("注册时发生错误：" + error.message);
        }
        unblockPage();
    };


    return (
        <div className="register">
            <h2>注册</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>用户名：</label>
                    <input 
                        type="text" 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)} 
                        required 
                    />
                </div>
                <div>
                    <label>密码：</label>
                    <input 
                        type="password" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        required 
                    />
                </div>
                <div>
                    <label>确认密码：</label>
                    <input 
                        type="password" 
                        value={confirmPassword} 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        required 
                    />
                </div>
                <button type="submit">注册</button>
            </form>
        </div>
    );
};

//============================================================================
export default Register;
